import type Message from 'owa-service/lib/contract/Message';
import {
    isSingleItemSelection,
    MailRowDataPropertyGetter,
    getComputedIsSingleItemSelection,
    getSelectedItemParts,
    getSelectedTableView,
    isItemPartOperation,
} from 'owa-mail-list-store';
import getItemForMailList from 'owa-mail-store/lib/selectors/getItemForMailList';
import { isFirstLevelExpanded } from 'owa-mail-list-store/lib/selectors/isConversationExpanded';
import type { TableView } from 'owa-mail-list-store';
import type { ClientItem } from 'owa-mail-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export default function getItemOrMessage(
    tableView: TableView
): Message | ClientItem | undefined | null {
    if (isGlobalFeatureEnabled('fwk-ml-reduce-render-scope')) {
        if (!getComputedIsSingleItemSelection()) {
            return undefined;
        }
        const rowKey = [...getSelectedTableView().selectedRowKeys.keys()][0];
        if (isItemPartOperation()) {
            const itemId = getSelectedItemParts()[0];
            return getItemForMailList(itemId, isFirstLevelExpanded(rowKey));
        } else if (rowKey) {
            return MailRowDataPropertyGetter.getItem(rowKey, tableView);
        }
        return undefined;
    }

    const selectedTableView = getSelectedTableView();
    const rowKey = isSingleItemSelection(selectedTableView)
        ? [...selectedTableView.selectedRowKeys.keys()][0]
        : '';
    if (isItemPartOperation()) {
        // Conversation view
        const itemId = getSelectedItemParts()[0]; // [0] for single selection
        return getItemForMailList(itemId, isFirstLevelExpanded(rowKey));
    } else if (rowKey) {
        return MailRowDataPropertyGetter.getItem(rowKey, tableView);
    }
    return undefined;
}
